<template>
  <div class="pc-withdraw-sidebar">
    <div class="pc-sidebar-title">
      {{ $t('Bao.withdraw') }}
    </div>
    <div
      class="sidebar-item"
      :class="{ active: !isCryptoExchange }"
      @click="isCryptoExchange && $emit('toggle-mode')"
    >
      <img :src="$getThemeImagePath('Withdraw-gold.svg')" alt="">
      <span>{{ $t('Bao.withdraw') }}</span>
    </div>
    <div
      v-if="themeConfig.isHasFiatCurrency"
      class="sidebar-item"
      :class="{ active: isCryptoExchange }"
      @click="!isCryptoExchange && $emit('toggle-mode')"
    >
      <img :src="$getThemeImagePath('crypto-exchange-gold.svg')" alt="">
      <span>{{ $t('Bao.crypto_exchange') }}</span>
    </div>
  </div>
</template>

<script>
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'WithdrawSidebar',
  mixins: [themeMixin],
  props: {
    isCryptoExchange: {
      type: Boolean,
      default: false
    }
  }
}
</script>
